// PRODUCTDEV-8800: what EvedPay Cards calls an envelope ("Envelope" or "Expense Report").
// A row from EvedPayCardEnvelopes/GetList carries its division's term; otherwise the client's, from GetUserSettings.

const text = value => typeof value === 'string' && value ? value : null

export function envelopeTermFor (row) {
  const user = global.app && global.app.$user
  const settings = (user && user.sessionSettings && user.sessionSettings.CompanySettings) || {}
  const labels = settings.Labels || {}

  const singular = text(row && row.EnvelopeTerm) || text(labels.EnvelopeTerm) || text(settings.EnvelopeTerm) || 'Envelope'
  const plural = text(row && row.EnvelopesTerm) || text(labels.EnvelopesTerm) || text(settings.EnvelopesTerm) || singular + 's'

  return { singular, plural, lower: singular.toLowerCase() }
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Card-envelopes/envelopeTerm.js